import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const ExternalLinkIcon = ({ size = 'xsl', color = 'black', style: overrideStyles = {}, ...attr }) => {

  return (
    <svg style={{ ...style, ...overrideStyles }} {...iconSizes[size]} {...attr} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M10.8333 4.3335H14.2524L6.79285 11.7931L8.20707 13.2073L15.6666 5.74771V9.16683H17.6666V3.3335V2.3335H16.6666H10.8333V4.3335ZM4.16663 3.16683H3.16663V4.16683V15.8335V16.8335H4.16663H15.8333H16.8333V15.8335V10.7293H14.8333V14.8335H5.16663V5.16683H9.27079V3.16683H4.16663Z" />
    </svg>
  );

};

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

export default ExternalLinkIcon;
